import React, {memo, useMemo} from 'react';
import {View} from 'react-native';
import {createUseStyle} from '@redlink/assets/styles';
import {UserAvatar, Text} from '@redlink/components/atoms';
import {useQuery, getPagePreviewProfileQuery} from '@redlink/services';

export const PreviewUserInfo = memo(({style, pageName}) => {
    const {styles} = useStyle();

    const {
        data: {PageProfilePreview: {fullname, avatar, bio} = {}},
    } = useQuery(getPagePreviewProfileQuery, {variables: {pageName}});

    const normalizedBio = useMemo(() => bio?.split('\n')[0], [bio]);

    return (
        <View style={[styles.container, style]}>
            <UserAvatar source={{uri: avatar?.thumbnailUrl}}/>
            <View style={styles.textContainer}>
                <Text style={styles.titleText}>{fullname}</Text>
                <Text numberOfLines={1} style={styles.subTitleText}>
                    {normalizedBio}
                </Text>
            </View>
        </View>
    );
});

const useStyle = createUseStyle(
    ({colors, shadow, size, ltrFlexDirection}) => ({
        container: {
            flexDirection: 'row',
            alignItems: 'center',
        },
        textContainer: {
            marginStart: 16,
            width: 200,
        },
        titleText: {
            fontWeight: 'bold',
            fontSize: 16,
            color: colors.title,
            lineHeight: 32,
            textAlign: 'left',
        },
        subTitleText: {
            fontSize: 14,
            color: colors.subtitle,
            lineHeight: 32,
            textAlign: 'left',
        },
    })
);
